import http from 'components/Profile/http';
import { Prescription } from '../data/usePrescriptions';
import { Indication } from '../data/useIndication';

const IsNotNullAndUndefined = (value: any) => {
  return value !== undefined && value !== null
};

export default function useValidateTherapyStatuses({
  patientId,
  appointmentId,
}: {
  patientId: number;
  appointmentId: number;
}) {
  const handleValidate = async () => {
    let indication_for_cannabis_therapy_error = true;
    let amount_error = true;
    let share_of_thc_error = true;
    let share_of_cbd_error = true;
    let procedure_error = true;

    const indications = await http
      .get(`medical/indications/?patient_id=${patientId}&appointment_id=${appointmentId}`)
      .then((r) => r.results as Array<Indication>);

    const prescriptions = await http
      .get(`medical/prescriptions/?patient_id=${patientId}&appointment_id=${appointmentId}`)
      .then((r) => r.results as Array<Prescription>);

    const { diagnosis } = await http.get(`medical/patients/${patientId}/`);

    if (indications.length) {
      // if there are many of the same cards, only one of them needs to meet the condition
      indication_for_cannabis_therapy_error = !indications.some(
        (i) => i.indication_for_cannabis_therapy,
      );
    }

    if (prescriptions.length) {

      // if there are many of the same cards, only one of them needs to meet the condition
      amount_error = !prescriptions.some((i) => i.amount);
      share_of_thc_error = !prescriptions.some((p) =>  IsNotNullAndUndefined(p.share_of_thc) && p.share_of_thc >= 0);
      share_of_cbd_error = !prescriptions.some((p) =>  IsNotNullAndUndefined(p.share_of_cbd) && p.share_of_cbd >= 0);
      procedure_error = !prescriptions.some((p) => p.procedure.length);
    }

    const diagnosis_error = !diagnosis.length;

    const hasError = [
      indication_for_cannabis_therapy_error,
      amount_error,
      share_of_thc_error,
      share_of_cbd_error,
      procedure_error,
      diagnosis_error,
    ].some((error) => error);

    return hasError
      ? {
          indication_for_cannabis_therapy_error: indication_for_cannabis_therapy_error
            ? 'Indikation für Therapieversuch mit med. Cannabis ist (weiterhin) gegeben.'
            : false,
          amount_error: amount_error ? 'Menge' : false,
          share_of_thc_error: share_of_thc_error ? 'Anteil THC' : false,
          share_of_cbd_error: share_of_cbd_error ? 'Anteil CBD' : false,
          procedure_error: procedure_error ? 'Empfohlene Dosierung/Einnahme' : false,
          diagnosis_error: diagnosis_error
            ? 'Bitte wählen Sie mindestens eine Diagnose aus.'
            : false,
        }
      : false;
  };

  return { handleValidate };
}
